<template>
	<v-row class="fill-height" no-gutters v-if="showStepper">
		<v-col :cols="12" :sm="$vuetify.breakpoint.xsOnly ? 12 : 8" :lg="9">
			<v-row no-gutters :class="`${$vuetify.breakpoint.xsOnly ? 'mobile-main-container-sale' : 'main-container-sale'} `">
				<v-col cols="12">
					<header-sale :titleLogoUrl="invLogoUrl" />
				</v-col>
				<v-col cols="12">
					<stepper-sale></stepper-sale>
					<div class="text-caption color-3 pt-1">
						<legal-text-event />
					</div>
				</v-col>
			</v-row>
		</v-col>

		<v-col v-if="!$vuetify.breakpoint.xsOnly" :cols="12" :sm="4" :lg="3">
			<order-summary-sale />
		</v-col>
	</v-row>
</template>

<script>
import OrderSummarySale from '@/components/saleLayout/OrderSummarySale.vue';
import HeaderSale from '../components/saleLayout/HeaderSale.vue';
import StepperSale from '../components/saleLayout/StepperSale.vue';
import LegalTextEvent from '../components/saleLayout/LegalTextEvent.vue';
import { mapActions } from 'vuex';

import api from '../api/api';
export default {
	components: {
		'header-sale': HeaderSale,
		'stepper-sale': StepperSale,
		'order-summary-sale': OrderSummarySale,
		'legal-text-event': LegalTextEvent
	},

	data() {
		return {
			invLogoUrl: '',
			showStepper: false,
			errorConfirmation: false,
			stepperResult: {
				showResult: true,
				isError: false,
				messageError: '',
				oper: ''
			}
		};
	},
	methods: {
		...mapActions(['SET_SALE_DATA', 'SET_EVENT_DATA', 'SET_EVENT_IMG', 'SET_PANEL_DISABLED', 'SET_ACTIVE_PANEL', 'SET_ORDER_RESULT']),
		handlePaymentResult({ oper }) {
			const params = { oper };

			api.externalSale
				.checkOrderStatus({ params })
				.then(() => {
					this.SET_ORDER_RESULT({
						purchaseReference: oper
					});
				})
				.catch(() => {
					this.SET_ORDER_RESULT({
						isError: true,
						messageError: 'El pago ha fallado',
						purchaseReference: oper
					});
				})
				.finally(() => {
					this.SET_ACTIVE_PANEL(3);

					this.SET_PANEL_DISABLED({
						panel1disabled: true,
						panel2disabled: true,
						panel3disabled: true,
						panel4disabled: false
					});

					this.showStepper = true;
				});
		},
		changeOrderStatus({ oper, es }) {
			if (oper && es && oper.length === 20) {
				const params = { oper, es };
				api.externalSale.changeOrderStatus({ params });
			}
		}
	},
	mounted() {},
	beforeRouteEnter(to, from, next) {
		const FV_EVENT_DATA = JSON.parse(window.localStorage.getItem('FV_EVENT_DATA'));
		const FV_EVENT_IMG = JSON.parse(window.localStorage.getItem('FV_EVENT_IMG'));
		const FV_SALE_DATA = JSON.parse(window.localStorage.getItem('FV_SALE_DATA'));
		if (to.path === '/order/result' && to.query.oper && to.query.es) {
			next((vm) => {
				const query = { oper: to.query.oper, es: to.query.es };

				vm.changeOrderStatus(query);
				Promise.all([vm.SET_SALE_DATA(FV_SALE_DATA), vm.SET_EVENT_DATA(FV_EVENT_DATA), vm.SET_EVENT_IMG(FV_EVENT_IMG)]).then(() =>
				 	vm.handlePaymentResult(vm.$route.query)
				);
			});
		} else if (to.path === '/order/ok' && to.query.oper) {
			next((vm) => {
				const query = { oper: to.query.oper };
				Promise.all([vm.SET_SALE_DATA(FV_SALE_DATA), vm.SET_EVENT_DATA(FV_EVENT_DATA), vm.SET_EVENT_IMG(FV_EVENT_IMG)]).then(() =>
					vm.handlePaymentResult(query)
				);
			});
		} else if (to.path === '/order/ko' && to.query.oper) {
			next((vm) => {
				const query = { oper: to.query.oper };

				Promise.all([vm.SET_SALE_DATA(FV_SALE_DATA), vm.SET_EVENT_DATA(FV_EVENT_DATA), vm.SET_EVENT_IMG(FV_EVENT_IMG)]).then(() =>
					vm.handlePaymentResult(query)
				);
			});
		} else {
			next('/');
		}
	}
};
</script>

<style>
.main-container-sale {
	padding-left: 35px;
	padding-right: 30px;
}

.mobile-main-container-sale {
	padding-left: 35px;
	padding-right: 30px;
}

.question-container {
	margin-top: 2rem;
	margin-bottom: 5rem;
}
</style>
